export const REQUEST_STATS_CLAIMS: string = 'REQUEST_STATS_CLAIMS';
export const SET_STATS_CLAIMS: string = 'SET_STATS_CLAIMS';
export const COUNT_CLAIMS_STATS: Number = 10;
